//changed due to package upgrade
import React, { useState, useEffect, useRef } from 'react';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { Divider, Grid } from '@mui/material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import MyProducts from '../MyProducts';
import WaitList from '../WaitList';
import ActivitySessions from '../ActivitySessions';
import MySchedules from '../MySchedules';
import jwtAxios from '@projectK/services/auth/JWT';
import ProfileinfoCard from 'apps/admin/src/modules/student/ProfileInfoCard';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import {isParent,isSuperAdmin ,isAdmin} from '@projectK/context/RolesProvider';

const LockerPage = () => {
  const { user } = useAuthUser();
  const { isMobile } = useMobileSettings();
  /********************************My Products***************************** */
  const [myProducts, setMyProducts] = useState([]);
  const [myProductsLoading, setMyProductsLoading] = useState(true);
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);
  const [isAdjustCreditsModalOpen, setIsAdjustCreditsModalOpen] =
  useState(false);
  useEffect(() => {
    fetchUserProduct();
  }, []);

  const fetchUserProduct = async () => {
    try {
      setMyProductsLoading(true);
      const route =
      isParent(user)
          ? `/products/productname/parent/${user.id}`
          : `/products/productname/${user.id}`;
      const response = await jwtAxios.get(route);
      const { data } = response;
      setMyProducts(data);
      setMyProductsLoading(false);
    } catch (error) {
      setMyProducts([]);
      setMyProductsLoading(false);
    }
  };

  const openAddProductsModal = () => {
    setIsAddProductModalOpen(true);
  };
  const openAdjustCreditsModal = () => {
    setIsAdjustCreditsModalOpen(true);
  };

  /*****************************My Schedule**************************/

  const [currentActivity, setCurrentActivity] = useState(null);
  const [scheduleLoading, setScheduleLoading] = useState(true);
  const [useDateFilterSession, setUseDateFilterSession] = useState(false);
  const [searchSession, setSearchSession] = useState('');
  const [showAllSession, setShowAllSession] = useState(false);

  const fetchMySchedule = async () => {
    try {
      setCurrentActivity([]);
      setScheduleLoading(true);
      const routeDate =
      isParent(user)
          ? '/user-members/active-session'
          : '/activity-session/user/active-session';

      const response = await jwtAxios.get(`${routeDate}/${user?.id}`, {
        params: {
          perPage: 'all',
          useDateFilter: useDateFilterSession,
          search: searchSession,
        },
      });
      const { data } = response;
      setCurrentActivity(data?.list);
      setScheduleLoading(false);
    } catch (error) {
      setScheduleLoading(false);
    }
  };

  useEffect(() => {
    if (!isMobile) {
      fetchMySchedule();
    }
  }, [useDateFilterSession, searchSession, isMobile]);

  /***************************Wait List******************************/
  const [waitListData, setWaitListData] = useState(null);
  const [waitListLoading, setWaitListLoading] = useState(true);

  const fetchWaitList = async () => {
    try {
      setWaitListLoading(true);
      let url;
      if (isParent(user)) {
        url = `/user-members/waitlist-session/${user?.id}`;
      } else if (
        isSuperAdmin(user) || isAdmin(user)
      ) {
        url = `/user-waitlist`;
      } else {
        url = `/activity-session/user/waitlist-session/${user?.id}`;
      }
      const response = await jwtAxios.get(url, {
        params: { perPage: 'all' },
      });
      const { data } = response;
      setWaitListData(data?.list);
      setWaitListLoading(false);
    } catch (error) {
      setWaitListLoading(false);
    }
  };

  useEffect(() => {
    if (!isMobile) {
      fetchWaitList();
    }
  }, [isMobile]);

  //********************************ActivitySession********************************//

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(true);
  const [search, setSearch] = useState('');
  const [useDateFilter, setUseDateFilter] = useState(true);

  const abortControllerRef = useRef(null);
  const fetchActivitySessions = async () => {
    setLoading(true);
    setList([]);
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    try {
      const routeDate =
      isParent(user)
          ? '/user-members/session'
          : '/activity-session/user/session';

      const response = await jwtAxios.get(`${routeDate}/${user?.id}`, {
        params: {
          perPage: 'all',
          useDateFilter: useDateFilter,
          search,
        },
        signal,
      });
      const { data } = response;
      setList(data?.list);
      setLoading(false);
    } catch (error) {
      if (error.message !== 'canceled') {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (!isMobile) {
      fetchActivitySessions();
    }
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [useDateFilter, search, isMobile]);

  const responsiveSize = { xs: 12, md: 4, lg: 4, xl: 3 };
  return (
    <AppScrollbar>
      <div
        className='locker-page2'
        style={{ marginBottom: isMobile ? '50px' : '0px' }}
      >
        <ProfileinfoCard />
        <Divider
          sx={{
            marginTop: 4,
            marginBottom: 5,
          }}
        />
        <AppGridContainer>
          {!isMobile && (
             <Grid size={{ xs: 12, md: 12,lg: 12 }} style={{ paddingTop: '10px' }}>
              <div className='schedules-student'>
                <MySchedules
                  fetchActivitySessions={fetchActivitySessions}
                  list={currentActivity}
                  loading={scheduleLoading}
                  fetchMySchedule={fetchMySchedule}
                  fetchUserProduct={fetchUserProduct}
                  setDateFilter={setUseDateFilterSession}
                  useDateFilter={useDateFilterSession}
                  setSearchQuery={setSearchSession}
                  searchSession={searchSession}
                  setShowAll={setShowAllSession}
                  showAll={showAllSession}
                  setLoading={setScheduleLoading}
                />
              </div>
            </Grid>
          )}

          <Grid
            size={{...responsiveSize}}
            className='activity-locker'
            style={{ paddingTop: '20px' }}
          >
            <div className='product-student'>
              <MyProducts
                loading={myProductsLoading}
                setLoading={setMyProductsLoading}
                settings={myProducts}
                fetchUserProduct={fetchUserProduct}
                fetchMySchedule={fetchMySchedule}
                fetchWaitList={fetchWaitList}
                fetchActivitySessions={fetchActivitySessions}
                isModalOpen={isAddProductModalOpen}
                setIsModalOpen={setIsAddProductModalOpen}
                openModal={openAddProductsModal}
                setIsAdjustCreditsModalOpen={setIsAdjustCreditsModalOpen}
                isAdjustCreditsModalOpen={isAdjustCreditsModalOpen}
                openAdjustCreditsModal={openAdjustCreditsModal}
              />
            </div>
          </Grid>

          {!isMobile && (
            <Grid size={{ xs: 12, md: 8,lg: 8,xl:9}} style={{ paddingTop: '20px' }}>
              <div className='activitySession-student'>
                <ActivitySessions
                  list={list}
                  loading={loading}
                  setLoading={setLoading}
                  setList={setList}
                  setDateFilter={setUseDateFilter}
                  setSearchQuery={setSearch}
                  setShowAll={setShowAll}
                  showAll={showAll}
                  useDateFilter={useDateFilter}
                  fetchActivitySessions={fetchActivitySessions}
                  fetchMySchedule={fetchMySchedule}
                  fetchWaitList={fetchWaitList}
                  fetchUserProduct={fetchUserProduct}
                />
              </div>
              <Grid size={{ xs: 12, md: 12,lg: 12 }} className='activity-locker' style={{    paddingTop: '20px'}}>  
                <div className='waitlist-student'>
                  <WaitList
                    waitListData={waitListData}
                    loading={waitListLoading}
                    fetchWaitList={fetchWaitList}
                    fetchActivitySessions={fetchActivitySessions}
                    fetchUserProduct={fetchUserProduct}
                    setLoading={setWaitListLoading}
                  />
                </div>
              </Grid>
            </Grid>
          )}
        </AppGridContainer>
      </div>
    </AppScrollbar>
  );
};

export default LockerPage;
